import { createTransform } from 'redux-persist';

import type { UserProps } from '../user/user.types';

// A login-service session is never written to localStorage: the login service restores it on load.
// Cognito sessions persist unchanged.
export const sanitizeUserPersist = (user: UserProps): UserProps =>
  user.authSessionKey ? { ...user, authSessionKey: '', authSource: '' } : user;

export const userPersistTransform = createTransform<UserProps, UserProps>(
  sanitizeUserPersist,
  (outboundState) => outboundState,
  { whitelist: ['user'] }
);
